export default __webpack_public_path__ + "static/media/undraw06.e679548c.svg";